import React from 'react'

export const GoodSignalIcon = () => {
    return (
        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5625 4.5H5.3125C5.03594 4.5 4.8125 4.72344 4.8125 5V13.5C4.8125 13.7766 5.03594 14 5.3125 14H7.5625C7.83906 14 8.0625 13.7766 8.0625 13.5V5C8.0625 4.72344 7.83906 4.5 7.5625 4.5ZM12.375 0H10.125C9.84844 0 9.625 0.223437 9.625 0.5V13.5C9.625 13.7766 9.84844 14 10.125 14H12.375C12.6516 14 12.875 13.7766 12.875 13.5V0.5C12.875 0.223437 12.6516 0 12.375 0ZM2.75 9H0.5C0.223437 9 0 9.22344 0 9.5V13.5C0 13.7766 0.223437 14 0.5 14H2.75C3.02656 14 3.25 13.7766 3.25 13.5V9.5C3.25 9.22344 3.02656 9 2.75 9Z" fill="#73D13D"/>
        </svg>
    )
}